import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { LinksService } from 'shared/domain';
import { SharedUtilCommonModule, TreetopPropertiesProvider } from 'shared/util-common';

import { FroalaConfigService } from '../froala-config.service';

import 'froala-editor/js/plugins.pkgd.min.js';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  imports: [FroalaViewModule, FroalaEditorModule, SharedUtilCommonModule],
  standalone: true,
})
export class TextEditorComponent implements OnInit {
  private translocoService = inject(TranslocoService);
  private froalaConfigService = inject(FroalaConfigService);
  private linksService = inject(LinksService);

  protected showEditor: boolean;
  protected focus: boolean;

  @Input() public textControl: UntypedFormControl;
  @Input() public data: string;
  @Input() public disableImageUpload? = false;
  @Input() public readonly = false;
  @Output() public updateDescription? = new EventEmitter<string>();

  options: any;
  editor: any;
  placeholder: string;
  froalaPlaceholder: string;

  public ngOnInit(): void {
    const _this = this;
    this.placeholder = this.translocoService.translate('NoDescription');
    this.froalaPlaceholder = this.translocoService.translate('AddDescription');
    this.setEditor();
    if (!this.textControl) {
      this.textControl = new UntypedFormControl();
      this.textControl.setValue(this.data || '');
      this.textControl.disable();
    }
    this.textControl.valueChanges.subscribe((_newValue) => {
      this.updateDescription.emit(this.textControl.value as string);
    });

    this.options.events.initialized = function () {
      const editor = this;

      editor.events.on('commands.before', function (cmd: string) {
        const link = editor.link.get() as HTMLElement;
        const hasElementId = link?.hasAttribute('data-element-id');

        if (!hasElementId) {
          return false;
        }

        if (cmd === 'linkOpen') {
          _this.linksService.openAnchorLinkFromTextEditor(link);
          return;
        }

        if (cmd === 'linkEdit') {
          return false;
        }
      });
      this.$tb.on('click', '.fr-command[data-cmd="insertLink"]', function () {
        editor.popups.refresh();
      });
    };
  }

  private setEditor(): void {
    if (this.textControl) {
      const uploadUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/attachments/unmanaged`;
      this.options = this.froalaConfigService.getEditorConfigFroala(uploadUrl, this.froalaPlaceholder, this.translocoService);
      this.options.toolbarButtons = this.froalaConfigService.getToolbar('normal', {
        disabledTools: this.disableImageUpload ? ['insertImage', 'insertVideo'] : [],
      });
      this.showEditor = true;
    } else {
      this.showEditor = false;
    }
  }
}
